var React = require('react');

function Icon1 (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"\n      .cls-1 {\n        fill: #fff;\n        fill-rule: evenodd;\n\n      }\n    ")),React.createElement("g",{"id":"_Слой_1-2","data-name":"Слой 1","key":1},React.createElement("path",{"className":"cls-1","d":"M50.47,8.48C47.14,5.28,40.37,.53,32.23,.04,20.57-.66,7.79,7.56,5.22,16.57c-3.24,2.08-8.31,7.48-2.71,12.45,7,6.21,18.52,8.51,26.44,8.6,7.92,.09,13.66-1.01,14.4-4.41,1.22-5.61-.23-7.04-1.74-8.54-.95-.94-1.92-1.9-2.27-3.95-.59-3.52,.83-10.37,7.96-7.51-.62,3.65,1.74,7.17,5.39,7.97,3.76,.82,7.47-1.57,8.29-5.33,.82-3.76-1.57-7.47-5.33-8.29-1.85-.4-3.69-.03-5.18,.9Z"}))]);
}

Icon1.defaultProps = {"id":"_Слой_2","data-name":"Слой 2","viewBox":"0 0 61.14 37.63"};

module.exports = Icon1;

Icon1.default = Icon1;
